/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Container } from './styles';

interface SwitchProps {
  handleChange: () => void;
  checked: boolean;
}

const Switch = (props: SwitchProps) => {
  const { handleChange, checked } = props;
  const id = `switch-${Math.random()}`;

  return (
    <Container>
      <div className="onoffswitch">
        <input
          id={id}
          type="checkbox"
          name="onoffswitch"
          className="onoffswitch-checkbox"
          onChange={() => {
            handleChange();
          }}
          checked={checked}
        />
        <label htmlFor={id} className="onoffswitch-label">
          <span className="onoffswitch-inner" />
          <span className="onoffswitch-switch" />
        </label>
      </div>
    </Container>
  );
};

export default Switch;
